import { authState } from 'rxfire/auth';
import auth from '~src/services/auth';
import { debugAdd } from '~src/helpers/debug';

export const currentUser$ = authState(auth);

debugAdd({ currentUser$ });

export default currentUser$;